import React from 'react'
import styled from 'styled-components'
import { Row } from 'components/common/layout'
import { SemiBoldText } from 'components/common/text'
import { theme } from 'infra/theme'
import { FiCheck, FiX } from 'react-icons/fi'

export const ProfileStatusChip: React.FCC<{ isCompleted: boolean }> = ({
  isCompleted,
  children,
}) => {
  return (
    <Chip isCompleted={isCompleted}>
      {isCompleted ? (
        <FiCheck size={18} strokeWidth={2.5} color={theme.color.gray2} />
      ) : (
        <FiX size={16} strokeWidth={2.5} color='#F4686D' />
      )}
      <ChipText isCompleted={isCompleted}>{children}</ChipText>
    </Chip>
  )
}

const Chip = styled(Row)<{ isCompleted: boolean }>`
  gap: 4px;
  height: 24px;
  padding: 4px 8px;
  background-color: ${(p) => (p.isCompleted ? 'none' : '#FFEAEE')};
  border-radius: 8px;
`

const ChipText = styled(SemiBoldText)<{ isCompleted: boolean }>`
  font-size: ${(p) => p.theme.fontSize.small};
  color: ${(p) => (p.isCompleted ? p.theme.color.gray2 : '#F4686D')};
`
